<template>
	<mw-dialog
		v-model="dialog"
		submitBtn
		cancelBtn
		@submit="submit"
		:title="response.completion_rate == 100  ? 'Submit this Section' : 'Are You Sure?'"
	>
		<template v-slot:button>
			<v-tooltip v-if="icon" left>
				<template v-slot:activator="{on}" >
				<v-btn v-on="on" icon @click="dialog = true">
					<v-icon v-if="icon">mdi-check</v-icon>
				</v-btn>
				</template>
				Submit Section
			</v-tooltip>
			<v-list-item v-else @click="dialog = true">
				<v-list-item-title>
					{{ $t("buttons.submit") }}
				</v-list-item-title>
			</v-list-item>
		</template>
		<template v-slot:dialog-body>
			<render-content v-if="response.completion_rate == 100" id="submita"></render-content>
			<render-content v-else id="submitb"></render-content>
		</template>
	</mw-dialog>
</template>

<style lang="less">
.button {
	cursor: pointer;
}
</style>
<script>
import MwDialog from "@c/ui/MwDialog";
import RenderContent from "@c/ui/RenderContent";

export default {
	name: "Complete",
	props: {
		id: { type: String }, // the ID of the response,
		icon: { type: Boolean, default: false },
	},
	data: () => {
		return {
			dialog: false,
			color: "green",
		};
	},
	computed: {
		response() {
			return this.$store.state.sectionResponses.data[this.id];
		},
	},
	components: {
		MwDialog,
		RenderContent
	},
	methods: {
		submit() {
			const self = this;
			self.$store
				.dispatch("sectionResponses/patch", {
					id: self.id,
					status: "complete",
				})
				.then(() => {
					self.dialog = false;
				});
		},
	},
};
</script>
